module.exports = __webpack_public_path__ + "static/media/microsoftoffice.b45374f1.svg";